import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbDateStruct, NgbDateParserFormatter, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormatDateService } from './format-date.service'
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';

@Component({
    selector: 'cylib-do-date-ng',
    templateUrl: './do-date-ng.component.html',
    styleUrls: ['./do-date-ng.component.css'],
    providers: [
        { provide: NgbDateParserFormatter, useClass: FormatDateService }]
})
export class DoDateNgComponent implements OnInit {

    @Input() DocDefTemplate: NJDocDefTemplate;
    @Input() customParameters: any;

    private _docData: NJDocData;
    @Input() set DocData(doData: NJDocData) {
        this._docData = doData;
        this.model = this.formatDateService.parse(this._docData.dataValue);
    }
    get DocData(): NJDocData {
        return this._docData;
    }

    @Input() isValid: boolean;
    @Input() public loaderKey: string;
    @Input() isEnabled: boolean;
    @Input() skipPostDocDefData: boolean;

    txtDocData: NJDocData;
    txtDocDefTemplate: NJDocDefTemplate;
    validateDate: string;
    isLoading: boolean = false;
    isLabelHidden: boolean = false;
    public isHidden: boolean = false;
    public isDirty: boolean = false
    LabelStylesText: any;
    errorMessage: string;
    TextBoxStyle: any;

    model: NgbDateStruct;
    displayMonths = 1;
    dateNow: Date = new Date(Date.now());
    minDate = { year: 1900, month: 1, day: 1 };
    maxDate = { year: 2099, month: 12, day: 31 };
    position: string = "bottom";
    allowBadDate: boolean = false;
    onKeydownKey: any;
    hasEvent: boolean = false;
    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() dateAfterViewInit: EventEmitter<DoDateNgComponent> = new EventEmitter<DoDateNgComponent>();

    constructor(public calendar: NgbCalendar, public formatDateService: FormatDateService,
        private data: DocDefPrimLibService, config: NgbDatepickerConfig) {
        config.minDate = { year: 1900, month: 1, day: 1 };
        config.maxDate = { year: 2099, month: 12, day: 31 };
    }

    ngOnInit() { 
        this.txtDocDefTemplate = this.DocDefTemplate;
        this.txtDocData = this.DocData
        this.model = this.formatDateService.parse(this.txtDocData.dataValue);
        if (this.customParameters) {
            if (this.customParameters['LabelStylesText'] != null) {
                let styles = this.data.replaceAll(this.customParameters['LabelStylesText'], "'", '"');
                this.LabelStylesText = JSON.parse(styles);
            }

            if (this.customParameters['isEnabled']) {
                if (this.customParameters['isEnabled'] == 'False')
                    this.isEnabled = false;
            }

            if (this.customParameters['isLabelHidden'] != null)
                if (this.customParameters['isLabelHidden'].toUpperCase() === "TRUE")
                    this.isLabelHidden = true;
        }

        this.setHiddenStatus();
    }
    private NgbDateMaxDate(dt:Date) {
        this.maxDate = { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() };
    }

    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        else this.isHidden = false;
    }

    ngOnChanges(): void {
        this.isLoading = true;
        this.txtDocDefTemplate = this.DocDefTemplate;
        this.txtDocData = this.DocData
        let txtValue = this.formatDateService.parse(this.txtDocData.dataValue);
        this.isLoading = false;

        if (this.customParameters['position'] != null) {
            this.position = this.customParameters['position'];
        }
        if (this.customParameters['DisplayDateEnd'] != null) {
            var endDate = this.customParameters['DisplayDateEnd'];
            if (endDate == "Date.now()") {
                this.NgbDateMaxDate(this.dateNow);
            }

        }
        if (this.customParameters['ValidateDate'] != null) {
            this.validateDate = this.customParameters['ValidateDate'];
        }
        if (this.customParameters['AllowBadDate'] != null) {
            this.allowBadDate = (this.customParameters['AllowBadDate']).toLowerCase() == 'true' ? true : false;
        }
        if (this.customParameters['StartDate'] != null) {
            if (!txtValue)
                this.model = this.calendar.getToday();
        }
        if (this.customParameters['hasEvent'] == 'Yes')
            this.hasEvent = true;
    }
    
    getInputStyle(): object {
        if (this.customParameters['InputStyles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['InputStyles'], "'", '"');
            if (styles == "") {
                styles = "{}";
            }
            this.TextBoxStyle = JSON.parse(styles);
            if (this.isValid)
                return this.TextBoxStyle;
            else {
                this.TextBoxStyle['background-color'] = "lightpink";
                return this.TextBoxStyle;
            }
        }
        else {
            if (this.isValid)
                return null
            else
                return { "background-color": "lightpink" };
        }
    }
    getTextStyle(): object {
        if (this.customParameters['StylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['StylesText'], "'", '"');
            return JSON.parse(styles);
        }
    }
    select(d: NgbDateStruct) {
        console.log(d, this.testNgbDateStruct(d));
        if (this.testNgbDateStruct(d)) {
            this.txtDocData.dataValue = this.formatDateService.format(d);
            if (!this.isLoading) {
                this.setDate(this.txtDocData.dataValue);
            }
        }
        else {
            if (this.allowBadDate)
                this.txtDocData.dataValue = d.toString();
            else
                this.txtDocData.dataValue = "";
            this.DocData.dataValue = this.txtDocData.dataValue;
            if (!this.isLoading) {
                this.updateDate();
            }
        }
    }
    testNgbDateStruct(obj: any) {
        if (obj != null && obj.day && obj.month && obj.year)
            return true;
        else
            return false;
    }
    onKeydown(event) {
        if (this.hasEvent) {
            this.onKeydownKey = event.key;
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = this.DocData;
            this.DocDefTemplate.indent = this.onKeydownKey;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            this.onKeydownKey = "";
            this.clickBut.emit(DOMessage);

        }
    }
    resetDate() {
        var value: NJDocData = new NJDocData();
        value.dataValue = "";
        value.docDataHdrId = this._docData.docDataHdrId;
        value.docDefTemplateID = this._docData.docDefTemplateID;
        value.docDefDataRowID = this._docData.docDefDataRowID;
        this._docData = value;
        this.txtDocData.dataValue = "";
        this.model = this.formatDateService.parse(this._docData.dataValue);
        this.updateDate();
    }
    // Set a valid date to the model
    setDate(strDate: string) {
        var njDocData: NJDocData = new NJDocData();
        if (strDate == null || strDate == "" || strDate == "01/01/1900") {
            njDocData.dataValue = "";
            this.txtDocData.dataValue = "";
        }
        else {
            njDocData.dataValue = strDate;
            this.txtDocData.dataValue = strDate;
        }
        njDocData.docDataHdrId = this._docData.docDataHdrId;
        njDocData.docDefTemplateID = this._docData.docDefTemplateID;
        njDocData.docDefDataRowID = this._docData.docDefDataRowID;
        this._docData = njDocData;
        this.model = this.formatDateService.parse(this._docData.dataValue);
        this.updateDate();
    }
    updateDate() {
        let lstDocData: DocdefDataVM = new DocdefDataVM();
        lstDocData.docdata.push(this.txtDocData);
        lstDocData.loaderKey = this.loaderKey;
        this.isDirty = true;
        var _doDate = this;
        if (this.validateDate) {
            var _resp;
            this.data.ValidateInput(lstDocData, this.validateDate)
                .subscribe(resp => {
                    _resp = resp.errmsg;

                    if (_resp) {
                        
                        this.errorMessage = _resp;
                        alert(_resp);

                    }
                    if ((this.customParameters.skipPostDocDefData == "True" || this.skipPostDocDefData == true) && this.customParameters.DontskipPostDocDefData != "True") {
                        return this.onSaveComplete();
                    }
                    else {
                        this.data.saveDocDefData(lstDocData)
                            .subscribe(function () {
                                return _doDate.onSaveComplete();
                            }, function (error) {
                                return _doDate.errorMessage = error;
                            });
                    }
                })
        }
        else {
            if ((this.customParameters.skipPostDocDefData == "True" || this.skipPostDocDefData == true) && this.customParameters.DontskipPostDocDefData != "True") {
                return this.onSaveComplete();
            }
            else {
                this.data.saveDocDefData(lstDocData)
                    .subscribe(function () {
                        return _doDate.onSaveComplete();
                    }, function (error) {
                        return _doDate.errorMessage = error;
                    });
            }
        }
    }

    onSaveComplete = function () {
        let DOMessage: DOData = new DOData();
        DOMessage.njDocData = this.DocData;
        DOMessage.njDocDefTemplate = this.DocDefTemplate;
        this.clickBut.emit(DOMessage);
    }

    labelClass(): string {
        if (this.customParameters['LabelWidth'] == null) {
            return "col-md-6 col-sm-6";
        } else {
            return this.customParameters['LabelWidth'];
        }
    }
    inputClass(): string {
        if (this.customParameters['InputWidth'] == null) {
            if (this.customParameters['FormGroupItem'] == null) {

                return "form-control col-md-6 col-sm-6";
            }
            else {
                return "form-control";
            }
        } else {
            return "form-control "+this.customParameters['InputWidth'];
        }
    }
    IsFormGroup() {
        if (this.customParameters['FormGroupItem'] == 'Yes')
            return "form-group flex-nowrap";
        else
            return "";
    }
    ngAfterViewInit() {
        this.dateAfterViewInit.emit(this);
    }
}

